var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 999.64 999.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "facebook-13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 499.82,
    cy: 499.82,
    r: 499.82,
    fill: "#1977f3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M694.74,644.67l22.14-144.51H578.27V406.39c0-39.5,19.33-78.09,81.46-78.09h63v-123s-57.21-9.77-111.9-9.77c-114.15,0-188.79,69.16-188.79,194.48V500.16H295.15V644.67H422.09V993.93a501.28,501.28,0,0,0,78.09,6.05,510.07,510.07,0,0,0,78.09-6.05V644.67Z",
    transform: "translate(-0.36 -0.33)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a497a1b63976bd686a28d585ae2f9534.svg";
export { ForwardRef as ReactComponent };